import { Skeleton } from '@orgus/ui';
import { DataGate, PageBody } from '../components/shell/PageBody.tsx';
import { AuditExplorer } from '../features/audit-ops/AuditExplorer.tsx';

function AuditSkeleton() {
  return (
    <div className="overflow-clip rounded-card border border-border bg-surface" role="status" aria-label="Loading the audit log">
      <div className="flex h-filter-bar items-center gap-2 border-b border-border-subtle px-row-x">
        <Skeleton className="h-control-sm w-56" />
        <Skeleton className="h-control-sm w-28" />
        <Skeleton className="h-control-sm w-28" />
      </div>
      {Array.from({ length: 10 }, (_, i) => (
        <div key={i} className="flex h-row items-center gap-4 border-b border-border-subtle px-row-x last:border-b-0">
          <Skeleton className="size-4" />
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3" style={{ width: `${24 + ((i * 11) % 25)}%` }} />
          <Skeleton className="ml-auto h-3 w-16" />
          <Skeleton className="h-3 w-12" />
        </div>
      ))}
    </div>
  );
}

/** Audit: every action taken through Orgus and every change to the hub, with who, what, where, when and the result. */
export default function Audit() {
  return (
    <PageBody wide>
      <DataGate skeleton={<AuditSkeleton />}>
        <AuditExplorer />
      </DataGate>
    </PageBody>
  );
}
